/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { GeoJsonFeatureCollectionDtoFromJSON, PreviewIncidentReportResponseFromJSON, } from '../models/index';
/**
 *
 */
export class DiscoveryApi extends runtime.BaseAPI {
    /**
     */
    discoveryGetClusterPreviewByLatAndLngAndZoomRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.lat !== undefined) {
                queryParameters['lat'] = requestParameters.lat;
            }
            if (requestParameters.lng !== undefined) {
                queryParameters['lng'] = requestParameters.lng;
            }
            if (requestParameters.zoom !== undefined) {
                queryParameters['zoom'] = requestParameters.zoom;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/discovery/cluster-preview`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PreviewIncidentReportResponseFromJSON));
        });
    }
    /**
     */
    discoveryGetClusterPreviewByLatAndLngAndZoom(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.discoveryGetClusterPreviewByLatAndLngAndZoomRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    discoveryGetIncidentsByBboxAndZoomAndStartDateAndEndDateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.bbox !== undefined) {
                queryParameters['bbox'] = requestParameters.bbox;
            }
            if (requestParameters.zoom !== undefined) {
                queryParameters['zoom'] = requestParameters.zoom;
            }
            if (requestParameters.startDate !== undefined) {
                queryParameters['startDate'] = requestParameters.startDate.toISOString();
            }
            if (requestParameters.endDate !== undefined) {
                queryParameters['endDate'] = requestParameters.endDate.toISOString();
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/discovery/incidents`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GeoJsonFeatureCollectionDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    discoveryGetIncidentsByBboxAndZoomAndStartDateAndEndDate(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.discoveryGetIncidentsByBboxAndZoomAndStartDateAndEndDateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
